import { ReactNode } from 'react';
import cn from 'classnames';
import { Badge } from '@round/creatorbase-ui';
import styles from './StatusBadge.module.css';

export type StatusBadgeTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

type Props = {
    tone: StatusBadgeTone;
    children: ReactNode;
    className?: string;
};

/** A soft tinted pill, so a status reads at a glance without shouting over the rows around it. */
const StatusBadge = ({ tone, children, className }: Props) => (
    <Badge variant="outline" className={cn(styles.badge, styles[tone], className)}>
        {children}
    </Badge>
);

export default StatusBadge;
